import useFormatDate from 'hooks/useFormatDate'
import { PotentialBid } from 'modules/domain/potentialBid/types'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'views/components/Card/Card'
import { KeyValue } from 'views/components/KeyValue/KeyValue'

type Props = {
  bid: PotentialBid
  setIsOpen: (v: boolean) => void
}

export const PotentialParamenters: FC<Props> = ({ bid, setIsOpen }) => {
  const { t } = useTranslation(['bid', 'common'])
  const formatDate = useFormatDate()

  return (
    <Card.GapableContent>
      <Card.Title>{t('form.bidsParams')}</Card.Title>
      <Card.Container bordered>
        <Card.GapableContent>
          <KeyValue label={t('common:quantity')}>{formatQuantity(bid.quantity)}</KeyValue>
          {bid.season && (
            <Card.Grid>
              <KeyValue label={t('season')}>{bid.season.name}</KeyValue>
            </Card.Grid>
          )}

          {bid?.presumable_sell_date && (
            <KeyValue label={t('form.presumableSellDate')}>{formatDate(bid.presumable_sell_date)}</KeyValue>
          )}

          {bid.parameters.length ? (
            <KeyValue label={t('form.cropsParams')}>
              {bid.parameters.map((p) => {
                return <div key={p.id}>{p.description}</div>
              })}
            </KeyValue>
          ) : null}
        </Card.GapableContent>

        <Card.EditButton onClick={() => setIsOpen(true)} />
      </Card.Container>
    </Card.GapableContent>
  )
}
